import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import StarRating from '@homeaway/react-star-rating';
import {TrackingContext} from '@homeaway/react-event-tracking';

import LazyLoad from '../lazy-load/LazyLoad';
import PlaceholderImage, {PlaceholderSvg} from '../carousel/Placeholder';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import ImageCardComponent from '../carousel/ImageCard';

const ACTION_LOCATION = 'property-reviews';

export class Review extends Component {
    static contextType = TrackingContext;

    onViewPropertyClick = (listingid, position) => () => {
        this.context.trigger('property.tile.click', {
            eventcategory: ACTION_LOCATION,
            eventrefinements: `position:${position}`,
            listingid,
        });
    };

    handleTripboardClick = (evt) => {
        evt.preventDefault();
    };

    renderTripboardComponent() {
        const {
            expandedTripboardButton,
            listing: {listingUri, propertyName, thumbnailUrl, tripleId},
            review: {rating},
            simpleName,
            tripboardComponent: TripboardComponent,
        } = this.props;

        return (
            TripboardComponent && (
                <TripboardComponent
                    actionlocation={ACTION_LOCATION}
                    expandedButton={expandedTripboardButton}
                    headline={propertyName}
                    href={listingUri}
                    listingId={tripleId}
                    newBoardName={simpleName}
                    onClick={this.handleTripboardClick}
                    averageRating={rating}
                    thumbnailUrl={thumbnailUrl}
                />
            )
        );
    }

    render() {
        const {
            aspectRatio = '4x3',
            baseCls,
            currentIndex,
            isMobile,
            listing: {
                listingUri,
                propertyName,
                thumbnailUrl,
                thumbnailUrl2,
                thumbnailUrl3,
                tripleId,
            },
            position,
            review: {body, dateStayed, headline, rating},
            reviewer: {location, nickname, profilePhotoUrl},
        } = this.props;

        const locationElement = location ? (
            <p className={`${baseCls}__location`}>{location}</p>
        ) : null;

        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        const images = [thumbnailUrl, thumbnailUrl2, thumbnailUrl3];

        const imgProps = {
            currentIndex,
            position,
            images,
            propertyName,
            listingUri,
            target: '_blank',
            onClick: this.onViewPropertyClick(tripleId, position),
        };
        return (
            <AspectRatioCard
                aspectRatio={aspectRatio}
                key={thumbnailUrl}
                hasHover={false}
                className={baseCls}
            >
                <div
                    key={'figure'}
                    data-slot={'figure'}
                    className={`${baseCls}__property-img-ct`}
                >
                    <LazyLoad
                        offset={offset}
                        placeholder={<PlaceholderImage alt={propertyName} />}
                    >
                        {imgProps.images[0] === '' ? (
                            <PlaceholderSvg />
                        ) : (
                            <ImageCardComponent {...imgProps} />
                        )}
                    </LazyLoad>
                </div>
                <div data-slot={'content'} className={`${baseCls}-ct`}>
                    {this.renderTripboardComponent()}
                    <a
                        className={`${baseCls}__content`}
                        href={listingUri}
                        onClick={this.onViewPropertyClick(tripleId, position)}
                        target={'_blank'}
                    >
                        <header className={`${baseCls}-hd`}>
                            <span className={`${baseCls}__details`}>
                                <span className={`${baseCls}__rating`}>
                                    <StarRating rating={rating} size={'24'} />
                                </span>
                                <span className={`${baseCls}__date-stayed`}>
                                    {dateStayed}
                                </span>
                            </span>
                        </header>
                        <div className={`${baseCls}-bd`}>
                            <h4 className={`${baseCls}__headline`}>
                                {headline}
                            </h4>
                            <p className={`${baseCls}__text`}>{body}</p>
                        </div>
                        <footer className={`${baseCls}-ft`}>
                            <div className={`${baseCls}__img-container`}>
                                <img
                                    className={`${baseCls}__img-container-reviewer`}
                                    src={profilePhotoUrl}
                                    alt={nickname}
                                />
                            </div>
                            <div className={`${baseCls}__details`}>
                                <h5 className={`${baseCls}__reviewer-name`}>
                                    {nickname}
                                </h5>
                                {locationElement}
                            </div>
                        </footer>
                    </a>
                </div>
            </AspectRatioCard>
        );
    }
}

Review.contextTypes = {
    trigger: PropTypes.func,
};

export default Review;
